import { useEffect } from 'react';

/** Brief confirmation or error message; dismisses itself. */
export default function Toast({ message, tone = 'info', onDismiss }) {
  useEffect(() => {
    if (!message) return undefined;
    const timer = setTimeout(onDismiss, tone === 'error' ? 6000 : 3000);
    return () => clearTimeout(timer);
  }, [message, tone, onDismiss]);

  if (!message) return null;

  return (
    <div
      className={`toast${tone === 'error' ? ' is-error' : ''}`}
      role="status"
      aria-live="polite"
    >
      {message}
    </div>
  );
}
